export const LOCALES = [
  { value: "en-AU", label: "English (AU)" },
  { value: "en-US", label: "English (US)" },
  { value: "en-GB", label: "English (UK)" },
  { value: "en-AE", label: "English (UAE)" },
];

export const CURRENCIES = ["AUD", "USD", "GBP", "EUR", "AED", "INR"];
